import React from 'react';
import Slider from 'react-slick';
import { images } from '../../utils/imagePaths';
import "../../styles/testimonials.css";
import "../../styles/section.css";

const NextArrow = ({ onClick }) => (
  <button className="t-arrow t-arrow-next" onClick={onClick} aria-label="Next">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 5l7 7-7 7" />
    </svg>
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="t-arrow t-arrow-prev" onClick={onClick} aria-label="Previous">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 5l-7 7 7 7" />
    </svg>
  </button>
);

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const testimonials = [
    {
      id: 1,
      text: "I have now been working with Xclusivesoftware for more than 5 years on various projects. They have been a team that's delivered well for us. They have a diverse set of talent pool and the organization is well run and stable.",
      name: "Rachel Smith",
      position: "Account Manager, Magnifi Group",
      image: images.testimonial,
    },
    {
      id: 2,
      text: "I have now been working with Xclusivesoftware for more than 5 years on various projects. They have been a team that's delivered well for us. They have a diverse set of talent pool and the organization is well run and stable.",
      name: "Rachel Smith",
      position: "Account Manager, Magnifi Group",
      image: images.testimonial,
    },
  ];

  return (
    <section className="client-testimonials" id="client-testimonials">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">What Clients Say</span>
          <h2 className="section-title">Client Testimonials</h2>
          <p className="section-head">Customer feedback is vital to keep relationships with customers</p>
        </div>

        <div className="testimonials-wrapper">
          <Slider {...settings} className="testimonials-slider">
            {testimonials.map((t) => (
              <div key={t.id}>
                <div className="testimonials-tile">
                  <div className="t-quote">"</div>
                  <div className="t-body">
                    <p className="t-text">{t.text}</p>
                    <div className="t-author">
                      <img src={t.image} alt={t.name} className="t-avatar" />
                      <div>
                        <div className="t-name">{t.name}</div>
                        <div className="t-role">{t.position}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;